import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { contact } from '@supay-expeditions/content';

@Component({
  imports: [RouterModule],
  selector: 'sx-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected contact = contact;
  /** "+56 9 5555 0424" → "+56955550424", for tel: and wa.me links. */
  protected phoneDigits = '+' + contact.phone.replace(/\D/g, '');
}
